import * as THREE from 'three';
import { VISUAL_SETTINGS, WIND_LIMITS } from '../constants.js';
import { generateBackgroundPlaneShaders } from './shaders/Shaders';

export function generateBackgroundPlane(velocityTexture, particlePositionDataTexture, viewableSphereCapMidpoint, viewableSphereCapRadius) {
  const { backgroundShaderMaterialVertexShader, backgroundShaderMaterialFragmentShader } = generateBackgroundPlaneShaders();
  const backgroundPlane = new THREE.PlaneGeometry(2, 2);

  const backgroundShaderMaterial = new THREE.ShaderMaterial({
    vertexShader: backgroundShaderMaterialVertexShader,
    fragmentShader: backgroundShaderMaterialFragmentShader,
    side: THREE.DoubleSide,
    depthTest: false,
    depthWrite: false,
    uniforms: {
      u_positionTexture: { value: null },
      u_velocityTexture: { value: velocityTexture },
      u_originalPositionTexture: { value: particlePositionDataTexture },
      u_delta: { value: 0 },
      u_randomSeed: { value: 0 },
      u_motionScale: { value: VISUAL_SETTINGS.motionScale },
      u_minLonVelocity: { value: WIND_LIMITS.minLon },
      u_maxLonVelocity: { value: WIND_LIMITS.maxLon },
      u_minLatVelocity: { value: WIND_LIMITS.minLat },
      u_maxLatVelocity: { value: WIND_LIMITS.maxLat },
      u_resetChance: { value: VISUAL_SETTINGS.respawnResetChance },
      u_viewableCircleRadius: { value: viewableSphereCapRadius },
      u_viewableCircleMidpoint: { value: viewableSphereCapMidpoint },
    },
  });

  const backgroundMesh = new THREE.Mesh(backgroundPlane, backgroundShaderMaterial);
  backgroundMesh.name = 'backgroundMesh';

  return backgroundMesh;
}
